import * as DB from "@/api/visitor.js"
import { request as Require } from "@/utils/require.js"
import { Toast } from "vant"

const state = () => ({
  visitorRcord: {},
  intervieweeSelected: {},
  applyForm: {
    applicationDate: "",
    appointmentDictionaryCode: "",
    appointmentDictionaryName: "",
    carCode: "",
    idNumber: "",
    useSystemPhone: true,
    intervieweeName: "",
    intervieweeIndex: "",
    intervieweePhone: "",
    peopleSum: "",
    personName: "",
    phone: "",
    remark: "",
    schoolCode: "",
    sex: "",
    faceUrl: "",
    faceFileList: [],
    faceUrlFileId: "1",
    healthCodeUrl: "",
    healthCodeFileList: [],
    healthCodeUrlFileId: "",
    travelCodeUrl: "",
    travelCodeFileList: [],
    travelCodeUrlFileId: "",
  },
})
const mutations = {
  setVisitorRcord(state, payload) {
    state.visitorRcord = payload
  },
  setIntervieweeSelected(state, payload) {
    state.intervieweeSelected = payload
  },
  setApplyForm(state, payload) {
    state.applyForm = payload
  },
  resetApplyForm(state) {
    state.applyForm = {
      applicationDate: "",
      appointmentDictionaryCode: "",
      appointmentDictionaryName: "",
      carCode: "",
      idNumber: "",
      useSystemPhone: true,
      intervieweeName: "",
      intervieweeIndex: "",
      intervieweePhone: "",
      peopleSum: "",
      personName: "",
      phone: "",
      remark: "",
      schoolCode: "",
      sex: "",
      faceUrl: "",
      faceFileList: [],
      faceUrlFileId: "1",
      healthCodeUrl: "",
      healthCodeFileList: [],
      healthCodeUrlFileId: "1",
      travelCodeUrl: "1",
      travelCodeFileList: [],
      travelCodeUrlFileId: "",
    }
  },
}

const actions = {
  // 动态查看访客申请详情
  async openAutoInfo(context, params) {
    const r = await Require({
      api: DB.openAutoInfo,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  // 访客配置查看
  async openConfInfo(context, params) {
    const r = await Require({
      api: DB.openConfInfo,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  // 老师端详情
  async teacherAppInfo(context, params) {
    const r = await Require({
      api: DB.teacherAppInfo,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  // 家长端详情
  async parentAppInfo(context, params) {
    const r = await Require({
      api: DB.parentAppInfo,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  // 访问类型列表
  async openDictionary(context, params) {
    const r = await Require({
      api: DB.openDictionary,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  // 新增访客申请
  async openSave(context, params) {
    const r = await Require({
      api: DB.openSave,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      return r
    }
  },
  async parentAppSave(context, params) {
    const r = await Require({
      api: DB.parentAppSave,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      return r
    }
  },
  async teacherAppSave(context, params) {
    const r = await Require({
      api: DB.teacherAppSave,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      return r
    }
  },

  // 修改访客申请
  async openChange(context, params) {
    const r = await Require({
      api: DB.openChange,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  // 查看学校访客申请列表
  async openPage(context, params) {
    const r = await Require({
      api: DB.openPage,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  async teacherAppPage(context, params) {
    const r = await Require({
      api: DB.teacherAppPage,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
      console.log({
        success: r.success,
        data: r.data,
        message: r.message,
      })
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    }
  },

  async parentAppPage(context, params) {
    const r = await Require({
      api: DB.parentAppPage,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
      console.log({
        success: r.success,
        data: r.data,
        message: r.message,
      })
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    }
  },

  // 访客搜索被仿人
  async visitorOpenTeacher(context, params) {
    const r = await Require({
      api: DB.visitorOpenTeacher,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  // 老师审批结果回调
  async teacherAppCallback(context, params) {
    const r = await Require({
      api: DB.teacherAppCallback,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  // 检查是否有历史数据 外部
  async openCheckHistory(context, params) {
    const r = await Require({
      api: DB.openCheckHistory,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },

  // 检查是否有历史数据 家长
  async parentCheckHistory(context, params) {
    const r = await Require({
      api: DB.parentCheckHistory,
      params: params,
    })
    if (r.success) {
      return {
        success: r.success,
        data: r.data,
        message: r.message,
      }
    } else {
      Toast.fail(r.message)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
